import React from 'react'
import './TweetGrid.scss'

export function TweetGrid({ children }) {
  return <div className="tweet-grid">{children}</div>
}

export function TweetGridCell({ col = 1, row = 1, scale = 1, children }) {
  const styles = {
    gridArea: `${row} / ${col}`,
    transform: `scale(${scale}) skewY(7deg) rotate(-7deg)`,
  }
  return (
    <div className="tweet-grid-cell" style={styles}>
      {children}
    </div>
  )
}
